import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data5_6_2 } from './data';
import imgSave from "../../../saveImg";
import Auth from "../../../Auth";
import ExportExcel from "@/method/components/ExportExcel"
const { MonthPicker } = DatePicker;
const { TextArea } = Input;


class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            note: { note: "" },
            loading: true,
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getTable5_6_2(this.state.date);
        // this.computeNum(this.state.data)
    }



    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        };
        const totalName = ['cm_thisyear_covers', 'cm_thisyear_rev', 'cm_lastyear_covers', 'cm_lastyear_rev', 'ytd_thisyear_covers', 'ytd_thisyear_rev', 'ytd_lastyear_covers', 'ytd_lastyear_rev'];
        for (let i in totalName) {
            data[20][totalName[i]] = 0;
        }
        // 计算总的统计
        for (let i in totalName) {
            for (let j = 0; j < 20; j++) {
                data[20][totalName[i]] += Number(data[j][totalName[i]]);
            }
        }
        // console.log(data , '计算前');return;
        // 计算其他需要计算的值
        for (let j = 0; j <= 20; j++) {
            // current_month计算
            data[j]['cm_thisyear_ac'] = Number(data[j]['cm_thisyear_covers']) == 0 ? 0 : (Number(data[j]['cm_thisyear_rev']) / Number(data[j]['cm_thisyear_covers'])).toFixed(2);
            data[j]['cm_lastyear_ac'] = Number(data[j]['cm_lastyear_covers']) == 0 ? 0 : (Number(data[j]['cm_lastyear_rev']) / Number(data[j]['cm_lastyear_covers'])).toFixed(2);

            data[j]['cm_comparison_covers'] = (Number(data[j]['cm_thisyear_covers']) - Number(data[j]['cm_lastyear_covers']));
            data[j]['cm_covers_percent'] = Number(data[j]['cm_lastyear_covers']) == 0 ? 0 : (Number(data[j]['cm_comparison_covers']) / Number(data[j]['cm_lastyear_covers'])).toFixed(2);

            data[j]['cm_comparison_ac'] = (Number(data[j]['cm_thisyear_ac']) - Number(data[j]['cm_lastyear_ac'])).toFixed(2);
            data[j]['cm_ac_percent'] = Number(data[j]['cm_lastyear_ac']) == 0 ? 0 : (Number(data[j]['cm_comparison_ac']) / Number(data[j]['cm_lastyear_ac'])).toFixed(2);

            data[j]['cm_comparison_rev'] = (Number(data[j]['cm_thisyear_rev']) - Number(data[j]['cm_lastyear_rev'])).toFixed(2);
            data[j]['cm_rev_percent'] = Number(data[j]['cm_lastyear_rev']) == 0 ? 0 : (Number(data[j]['cm_comparison_rev']) / Number(data[j]['cm_lastyear_rev'])).toFixed(2);

            // 本年度计算
            data[j]['ytd_thisyear_ac'] = Number(data[j]['ytd_thisyear_covers']) == 0 ? 0 : (Number(data[j]['ytd_thisyear_rev']) / Number(data[j]['ytd_thisyear_covers'])).toFixed(2);
            data[j]['ytd_lastyear_ac'] = Number(data[j]['ytd_lastyear_covers']) == 0 ? 0 : (Number(data[j]['ytd_lastyear_rev']) / Number(data[j]['ytd_lastyear_covers'])).toFixed(2);

            data[j]['ytd_comparison_covers'] = Number(data[j]['ytd_thisyear_covers']) - Number(data[j]['ytd_lastyear_covers']);
            data[j]['ytd_covers_percent'] = Number(data[j]['ytd_lastyear_covers']) == 0 ? 0 : (Number(data[j]['ytd_comparison_covers']) / Number(data[j]['ytd_lastyear_covers'])).toFixed(2);

            data[j]['ytd_comparison_ac'] = (Number(data[j]['ytd_thisyear_ac']) - Number(data[j]['ytd_lastyear_ac'])).toFixed(2);
            data[j]['ytd_ac_percent'] = Number(data[j]['ytd_lastyear_ac']) == 0 ? 0 : (Number(data[j]['ytd_comparison_ac']) / Number(data[j]['ytd_lastyear_ac'])).toFixed(2);

            data[j]['ytd_comparison_rev'] = (Number(data[j]['ytd_thisyear_rev']) - Number(data[j]['ytd_lastyear_rev'])).toFixed(2);
            data[j]['ytd_rev_percent'] = Number(data[j]['ytd_lastyear_rev']) == 0 ? 0 : (Number(data[j]['ytd_comparison_rev']) / Number(data[j]['ytd_lastyear_rev'])).toFixed(2);

        }
        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        // this.setState({
        //     data
        // });
        this.computeNum(data);
    }

    // 获取表格5_6_2内容
    getTable5_6_2 = (date) => {
        const dataBegin = JSON.stringify(data5_6_2);
        let data = JSON.parse(dataBegin);
        fetch(`/_5_6_2_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }
            this.computeNum(data);
            this.setState({ loading: false });

        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }
    // 保存表格5-6-2内容
    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_5_6_2', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getTable5_6_2(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table5_6_2', 1.5, '5.62', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const { data, date, print } = this.state;
        const columns = [{
            title: <div>Top 20  F&B Individual Account <br /> 餐饮消费个人账号排名前二十位 </div>,
            dataIndex: 'top20_account',
            key: 'top20_account',
            align: "center",
            fixed: !print && "left",
            width: 300,
            render: (text, record, index) => {
                if (index < 20 && !print) {
                    return (
                        <div className="table-padding table-color-number">
                            <Input
                                className="table_numInput"
                                defaultValue={text}
                                onBlur={(e) => {
                                    this.onChange('top20_account', e.target.value, index)
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding table-color-footer`} >
                            {text}
                        </div>
                    )
                }
            }
        }, {
            title: 'Current Month 本年当月',
            align: "center",
            width: 1800,
            children: [{
                align: "center",
                title: 'Current Month Actual - This Year 本年当月实际数',
                width: 450,
                children: [{
                    title: <div>Covers 人数</div>,
                    dataIndex: 'cm_thisyear_covers',
                    key: 'cm_thisyear_covers',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index < 20 && !print) {
                            return (
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('cm_thisyear_covers', value, index)
                                        }}

                                    />
                                </div>
                            )
                        } else {
                            return (
                                <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                    {text}
                                </div>
                            )
                        }
                    }
                }, {
                    title: <div>A/C  人均消费</div>,
                    dataIndex: 'cm_thisyear_ac',
                    key: 'cm_thisyear_ac',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`}>
                                {text}
                            </div>
                        )
                    }
                }, {
                    title: <div>REV 收益</div>,
                    dataIndex: 'cm_thisyear_rev',
                    key: 'cm_thisyear_rev',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index < 20 && !print) {
                            return (
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('cm_thisyear_rev', value, index)
                                        }}

                                    />
                                </div>
                            )
                        } else {
                            return (
                                <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`}>
                                    {text}
                                </div>
                            )
                        }
                    }
                }]
            }, {
                align: "center",
                title: 'Current Month Actual - Last Year 去年当月实际数',
                width: 450,
                children: [{
                    title: <div>Covers 人数</div>,
                    dataIndex: 'cm_lastyear_covers',
                    key: 'cm_lastyear_covers',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index < 20 && !print) {
                            return (
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('cm_lastyear_covers', value, index)
                                        }}

                                    />
                                </div>
                            )
                        } else {
                            return (
                                <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`}>
                                    {text}
                                </div>
                            )
                        }

                    }
                }, {
                    title: <div>A/C  人均消费</div>,
                    dataIndex: 'cm_lastyear_ac',
                    key: 'cm_lastyear_ac',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`}>
                                {text}
                            </div>
                        )
                    }
                }, {
                    title: <div>REV 收益</div>,
                    dataIndex: 'cm_lastyear_rev',
                    key: 'cm_lastyear_rev',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index < 20 && !print) {
                            return (
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('cm_lastyear_rev', value, index)
                                        }}

                                    />
                                </div>
                            )
                        } else {
                            return (
                                <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`}>
                                    {text}
                                </div>
                            )
                        }
                    }
                }]
            }, {
                align: "center",
                title: 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年',
                width: 900,
                children: [{
                    title: <div>Covers 人数</div>,
                    dataIndex: 'cm_comparison_covers',
                    key: 'cm_comparison_covers',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'cm_covers_percent',
                    key: 'cm_covers_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        )
                    }
                }, {
                    title: <div>A/C 人均消费</div>,
                    dataIndex: 'cm_comparison_ac',
                    key: 'cm_comparison_ac',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'cm_ac_percent',
                    align: "cm_ac_percent",
                    key: 'vap_percent',
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        )
                    }
                }, {
                    title: <div>REV 收益</div>,
                    dataIndex: 'cm_comparison_rev',
                    key: 'cm_comparison_rev',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'cm_rev_percent',
                    key: 'cm_rev_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        )
                    }
                }]
            },],
        }, {
            title: 'YTD 本年累计',
            align: "center",
            width: 1800,
            children: [{
                align: "center",
                title: 'YTD Actual - This Year 本年累计实际数',
                width: 450,
                children: [{
                    title: <div>Covers 人数</div>,
                    dataIndex: 'ytd_thisyear_covers',
                    key: 'ytd_thisyear_covers',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index < 20 && !print) {
                            return (
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('ytd_thisyear_covers', value, index)
                                        }}

                                    />
                                </div>
                            )
                        } else {
                            return (
                                <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            )
                        }

                    }
                }, {
                    title: <div>A/C  人均消费</div>,
                    dataIndex: 'ytd_thisyear_ac',
                    key: 'ytd_thisyear_ac',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )
                    }
                }, {
                    title: <div>REV 收益</div>,
                    dataIndex: 'ytd_thisyear_rev',
                    key: 'ytd_thisyear_rev',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index < 20 && !print) {
                            return (
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('ytd_thisyear_rev', value, index)
                                        }}

                                    />
                                </div>
                            )
                        } else {
                            return (
                                <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            )
                        }
                    }
                }]
            }, {
                align: "center",
                title: 'YTD Actual - Last Year 去年累计实际数',
                width: 450,
                children: [{
                    title: <div>Covers 人数</div>,
                    dataIndex: 'ytd_lastyear_covers',
                    key: 'ytd_lastyear_covers',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index < 20) {
                            return (
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('ytd_lastyear_covers', value, index)
                                        }}

                                    />
                                </div>
                            )
                        } else {
                            return (
                                <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            )
                        }

                    }
                }, {
                    title: <div>A/C  人均消费</div>,
                    dataIndex: 'ytd_lastyear_ac',
                    key: 'ytd_lastyear_ac',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )
                    }
                }, {
                    title: <div>REV 收益</div>,
                    dataIndex: 'ytd_lastyear_rev',
                    key: 'ytd_lastyear_rev',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        if (index < 20 && !print) {
                            return (
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('ytd_lastyear_rev', value, index)
                                        }}

                                    />
                                </div>
                            )
                        } else {
                            return (
                                <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            )
                        }
                    }
                }]
            }, {
                align: "center",
                title: 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',
                width: 900,
                children: [{
                    title: <div>Covers 人数</div>,
                    dataIndex: 'ytd_comparison_covers',
                    key: 'ytd_comparison_covers',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding  ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytd_covers_percent',
                    key: 'ytd_covers_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        )
                    }
                }, {
                    title: <div>A/C 人均消费</div>,
                    dataIndex: 'ytd_comparison_ac',
                    key: 'ytd_comparison_ac',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytd_ac_percent',
                    align: "center",
                    key: 'ytd_ac_percent',
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        )
                    }
                }, {
                    title: <div>REV 收益</div>,
                    dataIndex: 'ytd_comparison_rev',
                    key: 'ytd_comparison_rev',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytd_rev_percent',
                    key: 'ytd_rev_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <div className={`table-padding ${index < 20 ? '' : 'table-color-footer'}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        )
                    }
                }]
            },],
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table5_6_2" style={{ width: this.state.print ? 3950 : 'auto' }}>
                        <Row>5.6.2 Top 20  F&B Individual Account 餐饮消费个人账号排名前二十位 </Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                        note: { note: "" }
                                    });
                                    this.getTable5_6_2(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="export5_6_2"
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 3900 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 3900, y: 550 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>

                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {

                                this.setState({ print: true, loading: true }, () => {
                                    ExportExcel({
                                        id: "export5_6_2",
                                        date,
                                        name: "5.6.2 Top 20 F&B Individual Account 餐饮消费个人账号排名前二十位"
                                    });
                                    this.setState({ print: false, loading: false });
                                });

                            }}
                            loading={this.state.print}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_5_6">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-6/5-6-2/index.js